import { render, staticRenderFns } from "./AppNotices.vue?vue&type=template&id=5fcb6968&scoped=true"
import script from "./AppNotices.vue?vue&type=script&lang=js"
export * from "./AppNotices.vue?vue&type=script&lang=js"
import style0 from "./AppNotices.vue?vue&type=style&index=0&id=5fcb6968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb6968",
  null
  
)

export default component.exports